import { Promotional } from './Promotional';
import { StandardInstallment } from './StandardInstallment';
import {
    Calculation,
    PaymentStructure,
    PaymentFrequency,
} from '@servicetitan/financing-api-client';
import { DeferredInterest } from './DeferredInterest';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface ContainerProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
}

export const Container = ({ plan, currentFrequency }: ContainerProps) => {
    const { providerCategory } = useProviderConfig();

    // Default payment frequency to Monthly if not provided
    const defaultPaymentFrequency = currentFrequency ?? PaymentFrequency.Monthly;

    // For second-look providers, always display StandardInstallment
    if (providerCategory === 'second-look') {
        return <StandardInstallment plan={plan} currentFrequency={defaultPaymentFrequency} />;
    }

    // Handle different payment structures for first-look providers
    if (
        plan.paymentStructure === PaymentStructure.Promotional ||
        plan.paymentStructure === PaymentStructure.DeferredInterestAndPrincipal ||
        plan.paymentStructure === PaymentStructure.MixedInterest ||
        (plan.paymentStructure === PaymentStructure.NotSet && plan.hasPromo)
    ) {
        return <Promotional plan={plan} currentFrequency={defaultPaymentFrequency} />;
    }

    if (plan.paymentStructure === PaymentStructure.DeferredInterest) {
        return <DeferredInterest plan={plan} />;
    }

    return <StandardInstallment plan={plan} currentFrequency={defaultPaymentFrequency} />;
};
